import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F4F2F2]">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F4F2F2]/80 backdrop-blur-sm border-b border-[#CAC7C7]">
        <nav className="w-full px-8 py-4 flex justify-between items-center max-w-4xl mx-auto">
          <Link
            to="/"
            className="text-2xl font-serif text-[#2E2A23] tracking-tight hover:text-[#E94E1B] transition-colors"
          >
            Newsletter
          </Link>
          <Link
            to="/login"
            className="flex items-center gap-2 text-[#888185] hover:text-[#E94E1B] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-medium">Voltar</span>
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-8 py-12">
        <h1 className="font-serif text-4xl md:text-5xl text-[#2E2A23] mb-8">Termos de Uso</h1>
        <p className="text-[#888185] text-sm mb-12">Última atualização: Janeiro de 2026</p>

        <div className="prose prose-lg max-w-none text-[#888185]">
          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">1. Aceitação dos Termos</h2>
            <p className="leading-relaxed">
              Ao acessar e usar o Newsletter, você concorda em cumprir e estar vinculado a estes
              Termos de Uso. Se você não concordar com qualquer parte destes termos, não poderá
              acessar o serviço.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">2. Descrição do Serviço</h2>
            <p className="leading-relaxed">
              O Newsletter é uma plataforma de curadoria de conteúdo tecnológico que utiliza
              inteligência artificial para selecionar, categorizar e personalizar artigos e notícias
              relevantes para profissionais de tecnologia. O serviço inclui:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Curadoria automatizada de conteúdo de fontes confiáveis</li>
              <li>Personalização baseada em preferências e comportamento</li>
              <li>Recursos de salvamento e organização de conteúdo</li>
              <li>Recomendações personalizadas</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">3. Conta de Usuário</h2>
            <p className="leading-relaxed">
              Para usar o Newsletter, você deve criar uma conta fornecendo informações precisas e
              completas. Você é responsável por manter a confidencialidade de sua conta e senha, e
              por todas as atividades que ocorram em sua conta.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">4. Uso Aceitável</h2>
            <p className="leading-relaxed">Você concorda em não:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Usar o serviço para qualquer finalidade ilegal ou não autorizada</li>
              <li>Tentar acessar áreas restritas do sistema</li>
              <li>Interferir ou interromper o serviço ou servidores conectados</li>
              <li>Coletar informações de outros usuários sem consentimento</li>
              <li>Usar bots, scrapers ou outros meios automatizados para acessar o serviço</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">5. Propriedade Intelectual</h2>
            <p className="leading-relaxed">
              O conteúdo exibido no Newsletter é proveniente de fontes externas e permanece
              propriedade de seus respectivos autores e publicadores. O Newsletter fornece links
              para as fontes originais e não reivindica propriedade sobre o conteúdo curado.
            </p>
            <p className="leading-relaxed mt-4">
              A marca Newsletter, logotipos, design e código do aplicativo são propriedade do
              Newsletter e protegidos por leis de propriedade intelectual.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">
              6. Limitação de Responsabilidade
            </h2>
            <p className="leading-relaxed">
              O Newsletter é fornecido &ldquo;como está&rdquo; e &ldquo;conforme disponível&rdquo;.
              Não garantimos que o serviço será ininterrupto, seguro ou livre de erros. Não somos
              responsáveis pela precisão, completude ou utilidade do conteúdo curado de fontes
              externas.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">7. Modificações do Serviço</h2>
            <p className="leading-relaxed">
              Reservamo-nos o direito de modificar ou descontinuar o serviço a qualquer momento, com
              ou sem aviso prévio. Não seremos responsáveis perante você ou terceiros por qualquer
              modificação, suspensão ou descontinuação do serviço.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">8. Alterações nos Termos</h2>
            <p className="leading-relaxed">
              Podemos atualizar estes Termos de Uso periodicamente. Notificaremos sobre quaisquer
              alterações publicando os novos termos nesta página. Recomendamos revisar estes termos
              periodicamente.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">9. Contato</h2>
            <p className="leading-relaxed">
              Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco pelo email:{' '}
              <a href="mailto:contato@banquinha.com.br" className="text-[#E94E1B] hover:underline">
                contato@banquinha.com.br
              </a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-12 border-t border-[#CAC7C7]">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="font-serif text-xl text-[#2E2A23]">Newsletter</div>
            <div className="flex gap-6 text-sm text-[#888185]">
              <Link to="/terms" className="hover:text-[#E94E1B] transition-colors">
                Termos de Uso
              </Link>
              <Link to="/privacy" className="hover:text-[#E94E1B] transition-colors">
                Política de Privacidade
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
